import { request } from "./request";
import { GeoLocation } from "@/api/types";

/**
 * Gets longitude and latitude given a zipcode
 */
export async function getGeoLocationAPI(payload: { zipCode: string }): Promise<GeoLocation> {
  return await request<GeoLocation>({
    url: "/location/geolocate",
    method: "POST",
    data: {
      zip_code: payload.zipCode,
    },
  });
}
